module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_7016.d1bc9c70.png";